import React, { ReactElement, ReactNode } from "react";
import styles from "./index.module.css";

interface Props {
  children?: ReactNode;
}

const PriorityItem = ({ children }: Props): ReactElement => {
  return <span className={styles.priorityItem}>{children}</span>;
};

export default PriorityItem;
